export default function loaderToggle() { 
  document.querySelector('.loader-overlay').classList.toggle("is-open");
}